<div class="tw-relative">
  <img class="tw-cursor-pointer tw-rounded-full tw-m-5 tw-object-cover tw-object-center {{customClass}}" 
       [style.width.px]="size" 
       [style.height.px]="size" 
       [style.min-width.px]="size" 
       [style.min-height.px]="size"
       [src]="image ? image : IMG_URL" 
       alt="image cropped" 
       (click)="fileInput.click()"/>
  <div *ngIf="showIcon" class="tw-cursor-pointer tw-absolute tw-top-0 tw-left-36 tw-w-8 tw-h-8 tw-bg-main tw-text-fff tw-rounded-full tw-flex tw-justify-center tw-content-center">
    <i class="fas fa-camera tw-my-2" (click)="fileInput.click()"></i>
  </div>
  <input [hidden]="true" type="file" class="custom-file-input" #fileInput accept="image/*" (change)="uploadImage(fileInput.files)">

</div>
